var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-item swiper-slide"},[_c('a',{attrs:{"href":_vm.data.url,"title":_vm.data.short_title}},[_c('img',{key:_vm.data.id,staticClass:"swiper-item",attrs:{"src":_vm.data.covers[1],"alt":_vm.data.short_title}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }